import React from 'react';
import { Hammer, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLang } from '../contexts/LanguageContext';
export function StorySection() {
  const {
    t
  } = useLang();
  return <section id="nosotros" className="py-24 bg-dark relative overflow-hidden" data-id="element-482" data-mp="c2mpo0navf14">
      <div className="absolute right-0 bottom-0 w-[600px] h-[600px] bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-483" data-mp="80jbv5d5ryco"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-484" data-mp="14oz1t2k6k9qb">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-485" data-mp="zqxj4iqo2cfd">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-486" data-mp="vpkegbzb8fa1">
            <div className="w-16 h-16 rounded-2xl bg-dark-100 border border-white/10 flex items-center justify-center shadow-xl mb-8" data-id="element-487" data-mp="3bfx6u5d20w0o">
              <Hammer className="w-8 h-8 text-gold" data-id="element-488" data-mp="1o5ljy0x1y2wq" />
            </div>

            <h2 className="text-3xl md:text-5xl font-bold text-white mb-8 leading-tight" data-id="element-489" data-mp="1t695i72ihrjk">
              {t.story.title} <br data-id="element-490" data-mp="1f6i0gvtz3lhp" />
              <span className="text-gold" data-id="element-491" data-mp="1f9chedds2o6d">{t.story.titleHighlight}</span>
            </h2>

            <div className="space-y-6 text-lg text-gray-400" data-id="element-492" data-mp="1k879y71jrr3o">
              <p data-id="element-493" data-mp="15g5dyy2lli8x">{t.story.p1}</p>
              <p data-id="element-494" data-mp="15fvk2zefmqxy">
                {t.story.p2a}{' '}
                <strong className="text-white" data-id="element-495" data-mp="1a86lk6otmksm">{t.story.p2strong}</strong>
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-gradient-to-br from-dark-100 to-dark-200 p-8 md:p-12 rounded-3xl border border-white/5 shadow-2xl" data-id="element-496" data-mp="wi37w440bzes">
            <h3 className="text-2xl font-bold text-white mb-6" data-id="element-497" data-mp="2ofmgy38k5hxi">
              {t.story.missionTitle}
            </h3>
            <p className="text-xl font-medium text-gold border-l-4 border-gold pl-6 py-2 mb-8" data-id="element-498" data-mp="2kf2o3bv0p0h6">
              {t.story.missionQuote}
            </p>

            <div className="space-y-4" data-id="element-499" data-mp="3c5gsmhh550g6">
              {t.story.bullets.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-500" data-mp="3c34cm9uy105r" data-mpi={i}>
                  <CheckCircle2 className="w-5 h-5 text-gold shrink-0" data-id="element-501" data-mp="384deq0inlehl" />
                  <span className="text-white font-medium" data-id="element-502" data-mp="333ppnkdzj7q0">{item}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}